export default __webpack_public_path__ + "static/media/CodeIconW.4c87f172.svg";